<script setup>
const { id, slug, isToggle } = defineProps({
  id: String,
  slug: String,
  isToggle: {
    type: Boolean,
    default() {
      return true;
    },
  },
});

const route = useRoute();

const { data: sessionData, status } = useAuth();
const toast = useToast();

const compareLists = ref([]);

const addToCompare = () => {
  if (status.value !== "authenticated") return;

  let slugs = getCompareLists();
  if (slugs.includes(slug)) {
    if (compareLists.value.includes(slug)) {
      navigateTo("/compare");
    } else {
      toast.add({
        severity: "info",
        summary: "Already added to compare.",
        life: 3000,
      });
    }
  } else if (slugs.length > 2) {
    toast.add({
      severity: "info",
      summary: "You can compare maximum 3 programs.",
      life: 3000,
    });
    return;
  } else {
    if (slugs.length > 2) slugs = slugs.slice(1);
    slugs.push(slug);
    localStorage.setItem("compare-program", JSON.stringify(slugs));
    compareLists.value = slugs;
  }
  window.dispatchEvent(new Event("compare-program-updated"));
};

watch(
  () => localStorage.getItem("compare-program"),
  (newVal) => {
    compareLists.value = newVal ? JSON.parse(newVal) : [];
  },
);

const redirectToCompare = () => {
  if (
    status.value !== "authenticated" ||
    !sessionData?.value?.data?.student_profile_completed
  )
    return;

  addToCompare();
  navigateTo("/compare");
};

const getCompareLists = () => {
  const compare = localStorage.getItem("compare-program");
  return compare ? JSON.parse(compare) : [];
};

onMounted(() => {
  compareLists.value = getCompareLists();
});

const showSmall = computed(() => {
  return route.name.includes("programs-programSlug");
});
</script>

<template>
  <ProfileCompleteGuard v-if="!isToggle" @onCallback="redirectToCompare">
    <Button
      v-if="!isToggle"
      icon="pi pi-compass"
      label="Compare this program"
      class="text-[#1C477B] !text-sm"
      text
      @click="redirectToCompare"
    />
  </ProfileCompleteGuard>
  <ProfileCompleteGuard @onCallback="addToCompare" v-else>
    <Button
      label="Add to compare"
      severity="tertiary"
      class="hidden md:flex border-tertiary-100 !bg-tertiary-100 !hover:bg-tertiary-200 text-tertiary-500"
      @click="addToCompare"
    >
      <Checkbox
        :modelValue="compareLists.includes(slug)"
        binary
        readonly
        size="small"
      />
      <span
        class="text-sm text-tertiary-500 font-semibold"
        v-if="compareLists.includes(slug)"
        >Go to compare</span
      >
      <span class="text-sm text-tertiary-500 font-semibold" v-else
        >Add to compare</span
      >
    </Button>
    <Button
      label="Add to compare"
      severity="tertiary"
      class="flex md:hidden border-tertiary-100 !bg-tertiary-100 !hover:bg-tertiary-200 text-tertiary-500"
      @click="addToCompare"
      :size="showSmall ? 'small' : null"
    >
      <Checkbox
        :modelValue="compareLists.includes(slug)"
        binary
        readonly
        size="small"
      />
      <span
        class="text-sm text-tertiary-500 font-semibold"
        v-if="compareLists.includes(slug)"
        >Go to compare</span
      >
      <span class="text-sm text-tertiary-500 font-semibold" v-else
        >Add to compare</span
      >
    </Button>
  </ProfileCompleteGuard>
</template>
